<template>
  <div>
    <px-view-header title="Modos de pagamento" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-modos-de-pagamento-list-header :on-click-refresh="onClickRefresh"
                                       :on-change-filter="onChangeFilter" />
    <px-modos-de-pagamento-list :modos-de-pagamento="modosDePagamento"
                                :loading="loading"
                                :on-change-options="onChangeOptions"
                                :options-list="optionsList"
                                :footer-options="footerOptions"
                                @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-modos-de-pagamento/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import ModosPagamentoService from './modos-pagamento-service';
import ModosDePagamentoList from './ModosDePagamentoList.vue';
import ModosDePagamentoListHeader from './ModosDePagamentoListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Modos de pagamento' },
      ],
      modosDePagamento: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemModosDePagamento', ['stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('listagemModosDePagamento', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getModosDePagamento();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getModosDePagamento();
    },
    onClickRefresh() {
      this.getModosDePagamento();
    },
    onRemove(item) {
      this.loading = true;
      ModosPagamentoService.remover(item.id)
        .then(() => {
          this.$toast('Modo de pagamento removido com sucesso', { color: 'success' });
          this.getModosDePagamento();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getModosDePagamento() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return ModosPagamentoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.modosDePagamento = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxModosDePagamentoList: ModosDePagamentoList,
    pxModosDePagamentoListHeader: ModosDePagamentoListHeader,
  },
};

</script>
